import React, { useState } from 'react';
import { useLoginContext } from '../../Contexts/LoginContext';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import Button from '../Form/Button';
import { TbUserQuestion } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import { ImSpinner8 } from 'react-icons/im';

interface ButtonLoginSSOProps {
    className?: string;
    asButtonGray?: boolean;
    asLink?: boolean;
    hasLinkIcon?: boolean;
    labelLink?: string;
    iconSize?: number;
}

const ButtonLoginSSO = ({
    className,
    asButtonGray = false,
    asLink = false,
    hasLinkIcon = false,
    labelLink,
    iconSize = undefined

}: ButtonLoginSSOProps) => {

    const { t } = useTranslation();
    const { setShowLoginStoreCounter } = useLoginContext();
    const [ loading, setLoading ] = useState<boolean>(false);
    const { company } = useLayoutContext();

    const handleClickSSO = () => {
        setShowLoginStoreCounter(false);
        setLoading(true);

        const lang = localStorage.getItem('i18nextLng');
        const redirectPath = `${process.env.REACT_APP_URL_SSO_LOGIN!}?${new URLSearchParams({
            company: company.hash,
            redirect: window.location.pathname,
            ...(lang && { locale: lang }),
            }).toString()}`;

        window.location.href = redirectPath;
    }

    if (!company || !company.sso_active) return null;

        if (asLink) {
            return (
                <span className={`
                    flex items-center flex-nowrap gap-0.5 cursor-pointer 
                    ${className}
                    ${loading ? 'opacity-75' : ''}
                    `} onClick={handleClickSSO}>
                    {hasLinkIcon && (loading ? <ImSpinner8 size={iconSize} className='animate-spin' /> : <TbUserQuestion size={iconSize} />)}
                    {/* { labelLink ?? t('login.label_button_sso') } */}
                    {loading ? t('layout.loading_main.default_message') : labelLink ?? t('login.label_button_sso')}
                </span>
            )
        } else if (asButtonGray) {
            return (
                <Button
                    gray
                    onClick={handleClickSSO} className={`gap-1 ${className}`}
                    >
                    {(hasLinkIcon && !loading) && <TbUserQuestion size={iconSize} />}
                    {loading ? t('layout.loading_main.default_message') : labelLink ?? t('login.label_button_sso')}
                </Button>
            )
        } else {
            return (
                <Button
                    outline
                    disabled={loading}
                    onClick={handleClickSSO} 
                    className={`
                        relative justify-center items-center
                        min-h-max
                        flex gap-3
                        ${!company?.config?.website_authentication_type?.quick_purchase 
                            ? 'bg-custom-primary text-white ring-transparent hover:bg-custom-primary-hover' 
                            : 'bg-white ring-gray-400 hover:ring-gray-300'}
                        ${className}
                    `}
                >
                    <span className="flex items-center gap-1 leading-none">
                        {loading 
                            ?   <><ImSpinner8 size={iconSize} className='animate-spin' /> {t('layout.loading_main.default_message')}</> 
                            :   <><div><TbUserQuestion size={iconSize} /></div><div>{t('login.label_button_sso')}</div></>
                        }
                    </span>
                    {/* <img src="/icon-google.svg" alt="Google" className="h-4 absolute right-4" /> */}
                </Button>
            )
        }
}

export default ButtonLoginSSO;